import { Outlet } from 'react-router-dom';
import { Header } from './Header';

export const MainLayout = () => {
  return (
    <div className="bg-[#F5F5F5] min-h-screen pt-[64px] flex">
      <Header />
      <Outlet />
    </div>
  );
};
